module.exports = __webpack_public_path__ + "img/cards.b26cd99a.png";